export default __webpack_public_path__ + "static/17-3f65167e2a4ba30714ca4780138f91aa.jpg";